import { render, staticRenderFns } from "./PainelItemVisualizacao.vue?vue&type=template&id=0dcc122e&scoped=true"
import script from "./PainelItemVisualizacao.vue?vue&type=script&lang=js"
export * from "./PainelItemVisualizacao.vue?vue&type=script&lang=js"
import style0 from "./PainelItemVisualizacao.vue?vue&type=style&index=0&id=0dcc122e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcc122e",
  null
  
)

export default component.exports